'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserLoggedInSvg = exports.SearchClearSvg = exports.SearchSvg = exports.LogoSvg = exports.ChevronLeftSvg = exports.ChevronDownMastheadExtensionSvg = exports.ChevronDownMainMenuSvg = undefined;

var _uiSvg = require('@spp/ui-svg');

var _uiSvg2 = _interopRequireDefault(_uiSvg);

var _themeProvider = require('@spp/theme-provider');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronDownMainMenuSvg = exports.ChevronDownMainMenuSvg = (0, _themeProvider.themer)('@spp/cn-chevron-down-main-menu')(_uiSvg2.default);
var ChevronDownMastheadExtensionSvg = exports.ChevronDownMastheadExtensionSvg = (0, _themeProvider.themer)('@spp/cn-chevron-down-masthead-extension')(_uiSvg2.default);
var ChevronLeftSvg = exports.ChevronLeftSvg = (0, _themeProvider.themer)('@spp/cn-chevron-left')(_uiSvg2.default);
var LogoSvg = exports.LogoSvg = (0, _themeProvider.themer)('@spp/cn-logo')(_uiSvg2.default);
var SearchSvg = exports.SearchSvg = (0, _themeProvider.themer)('@spp/cn-masthead-search')(_uiSvg2.default);
var SearchClearSvg = exports.SearchClearSvg = (0, _themeProvider.themer)('@spp/cn-search-clear')(_uiSvg2.default);
var UserLoggedInSvg = exports.UserLoggedInSvg = (0, _themeProvider.themer)('@spp/cn-user-logged-in-button')(_uiSvg2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/svg/index.js
 ** module id = 45
 ** module chunks = 0
 **/